"use client"
import "../styles/Footer.css"
import { useLanguage } from "../contexts/LanguageContext"

const Footer = () => {
  const { t } = useLanguage()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <a href="/">
                <img src="https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569958/Logo_b6xvr2.png" alt="Gold House Logo" className="footer-logo-image" />
              </a>
              <p>Feel at Home. Anywhere.</p>
            </div>
          </div>

          <div className="footer-section">
            <h4>{t("quickLinks")}</h4>
            <ul>
              <li>
                <a href="/">{t("home")}</a>
              </li>
              <li>
                <a href="/#apartments">{t("apartments")}</a>
              </li>
              <li>
                <a href="/#about">{t("about")}</a>
              </li>
              <li>
                <a href="/#contact">{t("contact")}</a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>{t("contactInfo")}</h4>
            <ul>
              <li>
                <a href="mailto:info@goldhouse-apart.com" className="footer-contact-link" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" className="footer-icon email-icon">
                    <defs>
                      <linearGradient id="emailGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#d4a762" />
                        <stop offset="100%" stopColor="#e9c78e" />
                      </linearGradient>
                    </defs>
                    <path fill="url(#emailGradient)" d="M22,5V9L12,13,2,9V5A1,1,0,0,1,3,4H21A1,1,0,0,1,22,5ZM2,11.154l10,4.308,10-4.308V19a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1Z" />
                  </svg>
                  info@goldhouse-apart.com
                </a>
              </li>
              <li>
                <a href="https://wa.me/972584204297" target="_blank" rel="noopener noreferrer" className="footer-contact-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" className="footer-icon whatsapp-footer-icon">
                    <defs>
                      <linearGradient id="whatsappGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#d4a762" />
                        <stop offset="100%" stopColor="#e9c78e" />
                      </linearGradient>
                    </defs>
                    <path fill="url(#whatsappGradient)" d="M12,2C6.477,2,2,6.477,2,12c0,1.821,0.487,3.53,1.338,5.001l-0.895,3.274C2.275,20.822,2.518,21.5,3.14,21.757c0.175,0.072,0.356,0.106,0.533,0.106c0.212,0,0.419-0.051,0.614-0.154l3.274-1.517C9.084,21.383,10.513,21.75,12,21.75c5.523,0,10-4.477,10-10S17.523,2,12,2z" />
                    <path fill="white" d="M17.25,14.307c-0.261,0.735-1.521,1.391-2.092,1.469c-0.571,0.078-1.101,0.078-1.701-0.156c-0.4-0.156-0.911-0.39-1.532-0.702c-2.701-1.352-4.461-4.502-4.596-4.707c-0.13-0.208-1.1-1.458-1.1-2.786c0-1.328,0.701-1.978,0.951-2.248c0.25-0.27,0.541-0.338,0.721-0.338c0.18,0,0.36,0,0.52,0.01c0.167,0.01,0.391,0.016,0.601,0.459c0.25,0.52,0.797,1.797,0.867,1.927c0.07,0.13,0.12,0.28,0.02,0.45c-0.1,0.17-0.15,0.28-0.28,0.43c-0.13,0.15-0.272,0.335-0.392,0.45c-0.13,0.12-0.265,0.25-0.115,0.49c0.15,0.24,0.671,1.02,1.441,1.649c0.99,0.809,1.83,1.059,2.09,1.179c0.26,0.12,0.41,0.1,0.56-0.06c0.15-0.16,0.641-0.75,0.811-1.01c0.17-0.26,0.34-0.22,0.57-0.13c0.23,0.09,1.461,0.689,1.711,0.814c0.25,0.125,0.41,0.19,0.48,0.29C17.511,13.039,17.511,13.572,17.25,14.307z" />
                  </svg>
                  058-420-4297
                </a>
              </li>
              <li>
                <a href="https://www.google.com/maps/search/?api=1&query=14%20Beer%20Sheva%20Street%2C%20Nachlaot%2C%20Jerusalem" target="_blank" rel="noopener noreferrer" className="footer-contact-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" className="footer-icon location-icon">
                    <defs>
                      <linearGradient id="locationGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#d4a762" />
                        <stop offset="100%" stopColor="#e9c78e" />
                      </linearGradient>
                    </defs>
                    <path fill="url(#locationGradient)" d="M12,2a8,8,0,0,0-8,8c0,5.4,7.05,11.5,7.35,11.76a1,1,0,0,0,1.3,0C13,21.5,20,15.4,20,10A8,8,0,0,0,12,2Zm0,11a3,3,0,1,1,3-3A3,3,0,0,1,12,13Z" />
                  </svg>
                  {t("address")}
                </a>
              </li>
            </ul>
          </div>


        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-links">
            <a href="/privacy-policy" className="footer-bottom-link">
              {t("privacyPolicy")}
            </a>
            <span className="footer-bottom-separator"> | </span>
            <a href="/terms-of-use" className="footer-bottom-link">
              {t("termsOfUse")}
            </a>
          </div>

          <p>
            &copy; 2024 {t("allRightsReserved")} |{" "}
            <a
              href="https://renove-studio.com"
              target="_blank"
              rel="noopener noreferrer"
              className="copyright-link"
            >
              created by Renové-Studio
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                className="external-link-icon"
              >
                <path
                  fill="currentColor"
                  d="M14 3h7v7h-2V6.414l-9.293 9.293-1.414-1.414L17.586 5H14V3z"
                />
                <path
                  fill="currentColor"
                  d="M5 5h5V3H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5h-2v5H5V5z"
                />
              </svg>
            </a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
